// Generated by CoffeeScript 1.12.6
"use strict";
(function ($, win, doc) {
  let $doc, $win, swns;
  $win = $(win);
  $doc = $(doc);

  swns = {
    goToTop: function () {
      let funcTimeout;
      $("body").append("<p id='goto-top'></p>");
      $("#goto-top").hide();
      funcTimeout = function () {
        return $("#goto-top").fadeOut();
      };
      $.timeout = function (time) {
        return $.Deferred(function (dfd) {
          return setTimeout(dfd.resolve, time);
        }).promise();
      };
      $win.on("scroll", function () {
        let that;
        that = this;
        if ($(this).scrollTop() > 151) {
          return $("#goto-top").stop(true, true).fadeIn();
        } else {
          return $("#goto-top").fadeOut();
        }
      });
      return $("#goto-top").on("click", function (e) {
        e.preventDefault();
        return $("body,html").animate({
          scrollTop: 0
        }, 200);
      });
    }
  };

  /* plugin Type BlockLink */
  $.fn.blocklinkAssy = function () { // bind under this
    $(this).on("click", function (e) {
      e.preventDefault();
      win.open($(this).find("a").attr("href"), $(this).find("a").attr("target") || "_self");
    }).css({cursor: "pointer"});
  };


  $(() => {

    swns.goToTop();


    /*UI / UA */
    $("#content").find("h2,h3").each(function () {
      return $(this).wrapInner("<span class='add-span' />");
    });

    /* BlockLink Assy */
    $(".hNavi").blocklinkAssy();


    /**
     * swAnchor アンカー残し版（/#hoge） no return false;
     * @ fixup 外部リンクを避ける修正 & if(target.length) {}
     */
    $('a.swAnchor').click(function (e) {
      //e.preventDefault();
      let speed = 543;
      let href = $(this).attr("href");
      if (href.indexOf("#") === 0) {
        let target = $(href === "#" || href === "" ? 'html' : href);
        if (target.length) {
          let position = target.offset().top;
          $("html, body").animate({scrollTop: position - 30}, speed, "easeOutCirc");
          //return false;
        }
      }
    });

    /**
     * .parent-pageid-34 #breadcrumb a.post.post-page,
     .parent-pageid-2 #breadcrumb a.post.post-page {
       pointer-events: none;
       text-decoration: none;
       color: #303030;
     }
     */

    $('.parent-pageid-34 #breadcrumb a.post.post-page, .parent-pageid-2 #breadcrumb a.post.post-page').click(function (e) {
      return false;
    });


  });

})(jQuery, window, document);
